import React, { useState } from "react";
import { DefaultContext } from "react-icons/lib";
import { useLanguage } from "../../Translations/LenguageContext";
import { useNavigate } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import MandatorySign from "../../Components/MandatorySign";
import { phone_prefix } from "../../MCPs/ContstantValues";
import SupportedStripeCountries from "../../JSON/SupportedStripeCountries.json";
import { PiMagnifyingGlass } from "react-icons/pi";
import Spinner from "../../Components/Spinner";
import ErrorMessage from "../../Components/ErrorMessage";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const ContactSales = () => {
    const { t } = useLanguage()
    const navigate = useNavigate()
    const [step, setStep] = useState(1)
    const [searchTermPrefix, setSearchTermPrefix] = useState("");
    const [searchTermCountry, setSearchTermCountry] = useState("");
    const [error, setError] = useState({ message: "", display: false })
    const [loading, setLoading] = useState(false)

    const [formData, setFormData] = useState({
        full_name: "",
        phonePrefix: "+39",
        phone: "",
        email: "",
        message: "",
    });

    const filteredPhonePrefix = phone_prefix.filter((item) => {
        const search = searchTermPrefix.toLowerCase();
        return (
            item.name?.toLowerCase().includes(search) ||
            item.code?.toLowerCase().includes(search) ||
            item.dial_code?.toLowerCase().includes(search)
        );
    });

    const filteredCountries = SupportedStripeCountries.filter((item) => {
        const search = searchTermCountry.toLowerCase();
        return (
            item.value?.toLowerCase().includes(search) ||
            item.label?.toLowerCase().includes(search)
        );
    });

    const updateField = (field, value) => {
        setFormData((prev) => ({
            ...prev,
            [field]: value
        }));
    };

    const phoneRegex = /^\+?[0-9\s\-]{7,15}$/;

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    const validateEmail = (email) => {
        return emailRegex.test(email);
    };

    const handleContactSales = async () => {
        setError({ message: "", display: false });

        if (!formData.full_name) {
            setError({ message: t.website.sales.name_err_mex, display: true });
            return;
        }

        if (!formData.phonePrefix) {
            setError({ message: t.onboarding.personal_info.phone_prefix_required, display: true });
            return;
        }
        if (!formData.phone) {
            setError({ message: t.onboarding.personal_info.phone_required, display: true });
            return;
        }
        if (!phoneRegex.test(formData.phone)) {
            setError({ message: t.onboarding.personal_info.invalid_phone, display: true });
            return;
        }

        if (!formData.email) {
            setError({ message: t.website.sales.email_err_mex, display: true });
            return;
        }

        if (!validateEmail(formData.email)) {
            setError({ message: t.register_form.email_format, display: true });
            return;
        }

        setLoading(true);

        try {
            const response = await fetch(`${GEN_BACKEND_LINK}/contact_sales`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    full_name: formData.full_name,
                    phonePrefix: formData.phonePrefix,
                    phone: formData.phone,
                    email: formData.email,
                    message: formData.message
                }),
            });

            if (!response.ok) throw new Error("Failed to fetch user session");

            const data = await response.json();
            const status = data.status
            if (status == "OK") {
                setStep(2)
            }

            setTimeout(() => setLoading(false), 2000);
        } catch (error) {
            setLoading(false)
            setError({ message: "An error occurred while saving the info... retry in a few minutes", display: true })
        }
    };

    return (
        <div className="steps_main_container">
            <div className="contact_form">

                {step == 1 ? (
                    <div className="welcome_step_cont_inner">
                        <p className="step_title fade-in">{t.website.sales.contact_btn}</p>
                        <p className="step_description fade-in">{t.website.sales.subtitle}</p>
                        <div className="complete_profile_step_cont fade-in">
                            <div className="complete_profile_step_cont_form">
                                <div className="label_input">
                                    <label className="input_label">
                                        {t.full_name} <MandatorySign message={t.mandatory_field} />
                                    </label>

                                    <input
                                        type="text"
                                        placeholder={t.full_name}
                                        className="register_form_first fade-in"
                                        value={formData.full_name}
                                        onChange={(e) => updateField("full_name", e.target.value)}
                                    />
                                </div>

                                <div className="label_input">
                                    <label className="input_label">
                                        {t.onboarding.personal_info.phone} <MandatorySign message={t.mandatory_field} />
                                    </label>

                                    <div className="password_eye">
                                        <Dropdown>
                                            <Dropdown.Toggle as="div" className="phone_prefix_btn fade-in">
                                                {formData.phonePrefix}
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu className="custom_dropdown_menu_phone">
                                                <div className="scrollable_dropdown_cont">
                                                    {filteredPhonePrefix.map((item) => (
                                                        <button
                                                            key={item.code}
                                                            onClick={() => updateField("phonePrefix", item.dial_code)}
                                                            className={`settings_link ${formData.phonePrefix === item.dial_code ? "settings_link_selected" : ""}`}
                                                        >
                                                            {item.dial_code}
                                                        </button>
                                                    ))}
                                                    {filteredPhonePrefix.length == 0 && (
                                                        <button
                                                            className="settings_link"
                                                        >
                                                            {t.no_data_found}
                                                        </button>
                                                    )}
                                                </div>

                                                <div className="drop_filter">
                                                    <span className="drop_filter_icon"><PiMagnifyingGlass /></span>
                                                    <input
                                                        className="drop_filter_input"
                                                        placeholder="Search..."
                                                        value={searchTermPrefix}
                                                        onChange={(e) => setSearchTermPrefix(e.target.value)}
                                                    />
                                                </div>
                                            </Dropdown.Menu>
                                        </Dropdown>

                                        <input
                                            type="text"
                                            placeholder={t.onboarding.personal_info.phone}
                                            className="register_form_first fade-in"
                                            value={formData.phone}
                                            onChange={(e) => updateField("phone", e.target.value)}
                                            autoComplete="off"
                                        />
                                    </div>
                                </div>

                                <div className="label_input">
                                    <label className="input_label">
                                        Email <MandatorySign message={t.mandatory_field} />
                                    </label>

                                    <input
                                        type="text"
                                        placeholder="Email"
                                        className="register_form_first fade-in"
                                        value={formData.email}
                                        onChange={(e) => updateField("email", e.target.value)}
                                    />
                                </div>

                                <div className="label_input">
                                    <label className="input_label">
                                        {t.message}
                                    </label>
                                    <textarea
                                        name="description"
                                        maxLength={300}
                                        value={formData.message}
                                        onChange={(e) => updateField("message", e.target.value)}
                                        placeholder={t.website.sales.message_placeholder}
                                        className="register_form_first textarea_reg fade-in"
                                        autoComplete="off"
                                    />
                                </div>
                                <button onClick={handleContactSales} className="start_btn fade-in">
                                    {loading ? (
                                        <Spinner loading={loading} />
                                    ) : (
                                        <>
                                            {t.website.sales.contact_btn}
                                        </>
                                    )
                                    }
                                </button>
                            </div>
                        </div>
                        <ErrorMessage err={error} />

                    </div>
                ) : (
                    <div className="welcome_step_cont_inner">
                        <div className="complete_profile_step_cont fade-in">
                            <div className="complete_profile_step_cont fade-in">
                                <div className="complete_profile_step_cont_form">
                                    <p className="contact_title">{t.website.sales.req_success}</p>
                                    <p className="contact_subtitle">{t.website.sales.thanks}</p>

                                    <button className="start_btn" onClick={() => navigate("/")}>{t.website.sales.back_home_btn}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

            </div>

        </div>
    )
}

export default ContactSales